<template>
  <div id="ted-tf">
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import scrollMixin from "./mixins/scrollMixin";
import taggingMixin from "./mixins/taggingMixin";
import { mapMutations } from "vuex";
export default {
  name: "ted-tf",
  mixins: [scrollMixin, taggingMixin],
  methods: {
    ...mapMutations("userData", ["resetSections"]),
  },
  mounted: function () {
    // reload tool from home page on refresh in deep link
    if (this.$route.path !== "/") {
      // this.scrollToTop();
      // this.resetSections();
      // this.$router.push("/");
    }

    var url = window.location.href;
    this.tagPageViews(url, this.$route.path);
  },
};
</script>

<style lang="scss">
</style>
